const HorizontalSeparator = () => <hr className="h-px border-gray-400 opacity-70" />;

export default HorizontalSeparator;
